module.exports = __webpack_public_path__ + "img/about_3.89ef24f8.jpg";